module.exports = __webpack_public_path__ + "static/img/role.abe9e58.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/u/role.png
// module id = a/X6
// module chunks = 7